exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mail-container {\n  border-bottom: 1px solid #f2f7f8;\n}\n.mail-content p {\n  margin-bottom: 0;\n}\n\n", ""]);

// exports
